// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3scoT","header":"MessagesList_header__1WfAQ","chat":"MessagesList_chat__eEqdJ"};